//window.mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
//const mixpanel = window.mixpanel;
import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
export const Mixpanel = {
  trackEvent: (eventName, eventData,user) => {
    /*if(user){
      mixpanel.register({
        "user_name": user.name,
        "user_id": user.id,
        "user_mobile_number": user.contactNumber,
        "user_company_name": user.companyName,
        "user_city": user.city_name,
        "user_number_of_vehicles": user.no_of_vehicles,
        "user_profile_image": user.s3ProfileLink,
        "environment": process.env.REACT_APP_ENV
      });
      mixpanel.people.set({"Name": user.name });
      mixpanel.people.set({"Email": user.email });
      mixpanel.people.set({"Mobile Number": user.contactNumber });
      mixpanel.people.set({"Number of Vehicles": user.no_of_vehicles });
      mixpanel.people.set({"Company Name": user.companyName });
      mixpanel.people.set({"City": user.city_name });
      mixpanel.people.set({"State": user.state_name });
      mixpanel.people.set({"user_id": user.id});
      mixpanel.identify(user.id);
    }*/
    mixpanel.track(eventName, eventData);
  },

  userLogin: (user) => {
    mixpanel.register({
      "user_name": user.name,
      "user_id": user.id,
      "user_mobile_number": user.contactNumber,
      "user_company_name": user.companyName,
      "user_city": user.city_name,
      "user_number_of_vehicles": user.no_of_vehicles,
      "user_profile_image": user.s3ProfileLink,
      "environment": process.env.REACT_APP_ENV
    });
    mixpanel.people.set({
      "user_name": user.name,
      "user_id": user.id,
      "user_mobile_number": user.contactNumber,
      "user_company_name": user.companyName,
      "user_city": user.city_name,
      "user_number_of_vehicles": user.no_of_vehicles,
      "user_profile_image": user.s3ProfileLink,
    });
    //mixpanel.people.set({"Name": user.name });
    //mixpanel.people.set({"Email": user.email });
    //mixpanel.people.set({"Mobile Number": user.contactNumber });
    //mixpanel.people.set({"Number of Vehicles": user.no_of_vehicles });
    //mixpanel.people.set({"Company Name": user.companyName });
    //mixpanel.people.set({"City": user.city_name });
    //mixpanel.people.set({"State": user.state_name });
    //mixpanel.people.set({"user_id": user.id});
    mixpanel.identify(user.id);
  },

  userLogout: () => {
    mixpanel.reset();
  }
};